export const SHARE_ROUTES = {
  tag: '/app/users/:userId/tags/:id/:shareToken',
  album: '/app/users/:userId/albums/:id/:shareToken',
  container: '/app/users/:userId/containers/:id/:shareToken',
  person: '/app/users/:userId/people/:id/:shareToken',
  file: '/app/users/:userId/files/:fileId/:shareToken',
  profile: '/app/users/:userId',
  profileConnectionLink: '/app/invite/:userId/:token',
  embed: '/app/external/embed/:userId/:fileId/:shareToken',
  gift: '/app/gift/:token',
  digiProject: '/app/digitization-projects/:projectId/:shareToken',
  digiFile: '/app/digitization-projects/files/:fileId/:shareToken'
};

export const SHARE_EMBED_FRAME_MAX_VIDEO_DIMENSIONS = 560;

export const PROFILE_CONNECTION_INTENT_STORAGE_KEY = 'forever-profile-connect-intent';
export const PROFILE_CONNECTION_INTENT_MAX_AGE = 15 * 60 * 1000;
